import React from 'react'
import { SignInModal } from './SignInModal'
import { useAuthContext } from '../../Context'
import { logEvent } from '../../Utils'
import { ANALYTICS_TAGS } from '../../Constant'

export const GlobalSignInModal: React.FC = () => {
  const auth = useAuthContext()

  if (!auth.showLogin?.show) {
    return null
  }

  return (
    <SignInModal
      onClose={() => {
        logEvent(ANALYTICS_TAGS.login_cancelled)
        auth.handleToggleLogin()
      }}
      signInWithGoogle={auth.signInWithGoogle}
      signInWithEmLink={auth.signInWithEmLink}
      extraFields={auth.showLogin.extraFields}
      authLoading={auth.authLoading}
      isLoggedIn={auth.isLoggedIn || false}
      getMissingUserFields={auth.getMissingUserFields}
      sendPhoneVerification={auth.sendPhoneVerification}
    />
  )
}
